import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useSearchMutaion from '../../../../hooks/apis/useSearchMutaion';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { SER_BASIC_Schema } from './SER_BASIC_Schema';

/**
 * SER_BASIC(평가 목록) 관련 React Query 훅 모음
 */

// 기본정보 조회
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(SER_BASIC_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['SeriousAccidentAct', 'getSerBasicR1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.SeriousAccidentAct.getSerBasicR1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

// (필요 시) 조건 기반 조회: 현재 화면은 refetch로 충분하지만 다른 화면 패턴에 맞춰 준비
export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(SER_BASIC_Schema.mapper.search1, context);
    return apiRequest(
      'post',
      Global.urls.SeriousAccidentAct.getSerBasicR1,
      params
    );
  }, successOptions);
};

// 목록 삭제
// - 서버 DeleteSerBasicD1은 단건 Info 객체를 받으므로, 항상 첫 payload만 전송
export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows, context = {}) => {
    const payloads = mapRowsBySchema(
      rows,
      SER_BASIC_Schema.mapper.delete1,
      context
    );
    const payload = payloads?.[0] ?? {};
    return apiRequest(
      'post1',
      // NOTE: Global.urls에 deleteSerBasicD1을 추가해두었습니다.
      Global.urls.SeriousAccidentAct.deleteSerBasicD1,
      payload
    );
  }, options);
};
